const SESSION_CHECKED_KEY = "no_mobile_notice_checked";

let checkHandler = null;

/** 手机号是否为空（本地字段判断，备用） */
export function isMobileEmpty(mobile) {
  if (mobile == null || mobile === undefined) return true;
  return String(mobile).trim() === "";
}

/** /front/individual/hasMobile 返回：是否已绑定手机号 */
export function hasMobileBound(data) {
  if (!data || typeof data !== "object") return true;
  const v = data.hasMobile;
  return v === true || v === 1 || v === "true";
}

/** 是否需要展示「未绑定手机号」提示弹窗 */
export function shouldShowNoMobileDialog(data) {
  return !hasMobileBound(data);
}

export function isNoMobileNoticeChecked() {
  return sessionStorage.getItem(SESSION_CHECKED_KEY) === "1";
}

export function markNoMobileNoticeChecked() {
  sessionStorage.setItem(SESSION_CHECKED_KEY, "1");
}

/** 退出登录时清除，下次登录可再检测 */
export function clearNoMobileNoticeSession() {
  sessionStorage.removeItem(SESSION_CHECKED_KEY);
}

export function registerNoMobileNoticeChecker(fn) {
  checkHandler = typeof fn === "function" ? fn : null;
}

/** 登录成功后调用，本会话内仅检测一次 hasMobile */
export function triggerNoMobileNoticeAfterLogin() {
  sessionStorage.removeItem(SESSION_CHECKED_KEY);
  if (checkHandler) {
    checkHandler();
  }
}
